import { MyContext } from "@/store/myContext";
import React, { useContext } from "react";
import { useTranslation } from 'react-i18next';
import { DataBox } from "./DataBox";
import { PageHeader } from "./PageHeader";

export default () => {
    

const { t } = useTranslation();
const { state } = useContext(MyContext);

    return (
        <>
            {state.activeMenu === "yhBaseGoods" && <>
                <PageHeader />
                <DataBox />
            </>}
        </>
    )
}